// extracted by mini-css-extract-plugin
export default {"container":"QuartileBypassTable_container__KPO5h"};